import React, { useState } from 'react';

import { DangerButton, InfoButton } from '@magoosh/lib/button';
import { Select } from '@magoosh/lib/forms';
import { adminPaths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import { PromptRequest } from '../../types';

interface Props {
  onComplete: (promptRequest: PromptRequest) => void;
  promptRequest: PromptRequest;
}

const Actions: React.FC<Props> = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [accessLevel, setAccessLevel] = useState(null);
  const [examSectionId, setExamSectionId] = useState(null);

  const accept = () => {
    setIsSubmitting(true);

    fetch(adminPaths.api.testPrep.aiPromptRequestAccept(props.promptRequest.id), {
      method: 'POST',
      body: JSON.stringify({ accessLevel, examSectionId })
    }).then((response) => {
      setIsSubmitting(false);
      props.onComplete(response.promptRequest);
    }).catch((error) => {
      alert(error.errors._error);
      setIsSubmitting(false);
    });
  };

  const reject = () => {
    setIsSubmitting(true);

    fetch(adminPaths.api.testPrep.aiPromptRequestReject(props.promptRequest.id), {
      method: 'POST'
    }).then((response) => {
      setIsSubmitting(false);
      props.onComplete(response.promptRequest);
    }).catch((error) => {
      alert(error.errors._error);
      setIsSubmitting(false);
    });
  };

  return (
    <div className="align-items-center d-flex gap-s">
      {
        props.promptRequest.acceptanceOptions.examSections.length !== 0 && (
          <Select
            groupClassName="u-margin-A-n"
            onChange={(e) => setExamSectionId(e.target.value)}
            value={examSectionId}
          >
            <option>Exam Section</option>
            {
              props.promptRequest.acceptanceOptions.examSections.map((examSection) => (
                <option key={examSection.value} value={examSection.value}>{examSection.name}</option>
              ))
            }
          </Select>
        )
      }

      <Select
        groupClassName="u-margin-A-n"
        onChange={(e) => setAccessLevel(e.target.value)}
        value={accessLevel}
      >
        <option>Access Level</option>
        {
          props.promptRequest.acceptanceOptions.accessLevels.map((accessLevel) => (
            <option key={accessLevel.value} value={accessLevel.value}>{accessLevel.name}</option>
          ))
        }
      </Select>

      <DangerButton onClick={reject} submitting={isSubmitting}>Reject</DangerButton>
      <InfoButton onClick={accept} submitting={isSubmitting}>Create Prompts</InfoButton>
    </div>
  );
};

export default Actions;
